module.exports = __webpack_public_path__ + "static/media/share-icon.7861783d.svg";